// @flow

import React, { type Node } from 'react';
import { Empty } from '@tectonics/look-and-feel/volcanes/atoms';
import { type PaymentMethodCode } from '@tectonics/prs/payment-method';
import { DisplayNupayInstructions } from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/payment-method-selector/payment-method-item/display-instructions/display-nupay';
import { DisplayMpcreditoInstructions } from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/payment-method-selector/payment-method-item/display-instructions/display-mpcredito';

type Props = {|
  paymentMethodCode: PaymentMethodCode,
|};

export function DisplayInstructions({ paymentMethodCode }: Props): Node {
  switch (paymentMethodCode) {
    case 'nupay':
      return <DisplayNupayInstructions />;

    case 'mpcredito':
      return <DisplayMpcreditoInstructions />;

    default:
      return <Empty />;
  }
}
